export const actionTypes = (prefix) => ({
  load:         prefix + '/load',
  addColumn:    prefix + '/addColumn',
  removeColumn: prefix + '/removeColumn',
  updateColumn: prefix + '/updateColumn',
  update:       prefix + '/update',
  applyFilter:  prefix + '/applyFilter',
  clearFilters: prefix + '/clearFilters',
  updating:     prefix + '/updating'
})
